/* ==========================================================================
   KLUBS — comportements partagés des sections (partage & copie de lien)
   Délégation au niveau document : survit aux re-rendus de section du
   Customizer (shopify:section:load) sans ré-initialisation.
   Chargé plusieurs fois (un tag par section) → garde anti-double-init.
   ========================================================================== */
(function () {
  'use strict';
  if (window.__klubsSectionsJS) return;
  window.__klubsSectionsJS = true;

  function flashLabel(el, text, restoreHtml) {
    var orig = restoreHtml ? el.innerHTML : el.textContent;
    el.textContent = text;
    setTimeout(function () {
      if (restoreHtml) {
        el.innerHTML = orig;
      } else {
        el.textContent = orig;
      }
    }, 2500);
  }

  function copyText(text, onSuccess) {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(text).then(onSuccess).catch(function () {
        legacyCopy(text, onSuccess);
      });
    } else {
      legacyCopy(text, onSuccess);
    }
  }

  function legacyCopy(text, onSuccess) {
    var ta = document.createElement('textarea');
    ta.value = text;
    ta.setAttribute('readonly', '');
    ta.style.position = 'absolute';
    ta.style.left = '-9999px';
    document.body.appendChild(ta);
    ta.select();
    try {
      document.execCommand('copy');
      onSuccess();
    } catch (e) { /* rien : le champ reste sélectionnable à la main */ }
    document.body.removeChild(ta);
  }

  document.addEventListener('click', function (e) {
    /* ─── Bouton « Partager » (Web Share API, repli copie) ─── */
    var shareBtn = e.target.closest('[data-share-url]');
    if (shareBtn) {
      var url = shareBtn.getAttribute('data-share-url');
      var title = shareBtn.getAttribute('data-share-title') || document.title;
      if (navigator.share) {
        navigator.share({ title: title, url: url }).catch(function () {});
      } else {
        copyText(url, function () {
          flashLabel(shareBtn, '✓ Lien copié', true);
        });
      }
      return;
    }

    /* ─── Bouton « Copier le lien » (v1 et v2) ─── */
    var copyBtn = e.target.closest('[data-ck-copy], [data-ckv2-copy]');
    if (copyBtn) {
      var group = copyBtn.parentElement;
      var input = group ? group.querySelector('input') : null;
      if (!input) return;
      var label = copyBtn.querySelector('[data-ck-copy-label], [data-ckv2-copy-label]');
      copyText(input.value, function () {
        copyBtn.classList.add('is-copied');
        setTimeout(function () { copyBtn.classList.remove('is-copied'); }, 2500);
        flashLabel(label || copyBtn, '✓ Copié', false);
      });
    }
  });
})();
